/**
 * @generated SignedSource<<ece0919a210000cf512aefa69a030c83>>
 * @relayHash e3b5b71fba9dd3f54fb8973290ef6043
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4aab61ca8a29b1a5dfaedd2cb2eb2392eaeb65d57e63642b5704289a568bf312

import type { ConcreteRequest } from 'relay-runtime';
export type useRenderLivePageEarlyContentSubTypeAndStatusQuery$variables = {
  contentId: string;
  versionOverride?: number | null;
};
export type useRenderLivePageEarlyContentSubTypeAndStatusQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly status: string | null;
      readonly subType: string | null;
    } | null> | null;
  } | null;
};
export type useRenderLivePageEarlyContentSubTypeAndStatusQuery = {
  response: useRenderLivePageEarlyContentSubTypeAndStatusQuery$data;
  variables: useRenderLivePageEarlyContentSubTypeAndStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "versionOverride"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "version",
        "variableName": "versionOverride"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          },
          {
            "kind": "ScalarField",
            "name": "subType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRenderLivePageEarlyContentSubTypeAndStatusQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRenderLivePageEarlyContentSubTypeAndStatusQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e3b5b71fba9dd3f54fb8973290ef6043",
    "id": "4aab61ca8a29b1a5dfaedd2cb2eb2392eaeb65d57e63642b5704289a568bf312",
    "metadata": {},
    "name": "useRenderLivePageEarlyContentSubTypeAndStatusQuery",
    "operationKind": "query",
    "text": "query useRenderLivePageEarlyContentSubTypeAndStatusQuery($contentId:ID!,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,status,subType}}}"
  }
};
})();

(node as any).hash = "8c578b35282d8016db5ec0613d83d461";

export default node;
